import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { useConfig } from '@ynap/immutables-provider';
import { ratioToPadding } from '../utils';

const bem = new BEMHelper('AspectRatio');

const propTypes = {
    aspectRatio: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};

function AspectRatio({ aspectRatio, children, className, ...rest }) {
    let ratioClass;
    let paddingValue;
    const { content = className, wrapper } = className || {};
    const { head: { aspectRatio: { productImage } = {} } = {} } = useConfig() || {};

    const finalAspectRatio = aspectRatio || productImage;

    if (!finalAspectRatio) {
        // This is so a brand can have a default image ratio size
        ratioClass = 'defaultRatio';
    } else {
        switch (finalAspectRatio) {
            case '1:1':
                ratioClass = 'ratio1-1';
                break;
            case '2:3':
                ratioClass = 'ratio2-3';
                break;
            case '3:4':
                ratioClass = 'ratio3-4 ';
                break;
            case 'none':
                ratioClass = 'none';
                break;
            case 'background':
                ratioClass = 'background';
                break;
            case 'ratio100vh':
                ratioClass = 'ratio100vh';
                break;
            default:
                paddingValue = ratioToPadding(finalAspectRatio);
        }
    }

    const style = paddingValue ? { paddingTop: paddingValue, position: 'relative' } : null;

    return (
        <div className={bem(null, ratioClass, wrapper)} style={style} {...rest}>
            <div className={bem('content', null, content)}>{children}</div>
        </div>
    );
}

AspectRatio.propTypes = propTypes;

export default AspectRatio;
